import { render, staticRenderFns } from "./LctoPesagensPennState.vue?vue&type=template&id=64130f59&"
import script from "./LctoPesagensPennState.vue?vue&type=script&lang=js&"
export * from "./LctoPesagensPennState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports